module.exports = __webpack_public_path__ + "static/media/faust-artwork.903c4a6a.jpg";